
<template>
    <div>
        <div id="unsafeEchart"></div>
    </div>
</template>
 
<script>
import Echarts from 'echarts'
export default {
    name:'unsafeTypeEcharts',
    data() {
        return{
            myChart: {}
        }
    },
    props:{
        echartsData:{
            type:Array,
            default:{
                return: []
            }
        }
    },
    created() {
        this.$nextTick(()=> {
            this.loadEchart()
        })
    },
    mounted(){
        let _this = this;
        // window.onresize = function() {
        //     _this.myChart.resize()
        // }
    },
    methods: {
        loadEchart() {
            let colors = ['#71D6FF','#3A88F1','#50E238','#F13A3A','#C474FF']
            this.myChart = Echarts.init(document.getElementById("unsafeEchart"));
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    type: 'scroll',
                    orient: 'horizontal',
                    bottom: 10,
                    left: 'center',
                    itemWidth:12,
                    itemHeight:12,
                    textStyle:{
                        color:'#C4CDFF'
                    },
                    data: []
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        avoidLabelOverlap:true,
                        radius: [30, '60%'],
                        center: ['50%', '40%'],
                        data: [],
                        label:{

                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 100,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ],
                color:colors
            };
            option.series[0].data = this.echartsData.map((item)=>{
                return {
                    name:item.riskTypeName || item.name || '',
                    value:item.totalNum || item.value || 0
                }
            })
            option.legend.data = this.echartsData.map((item)=>{
                return item.riskTypeName || item.name || ''
            })
            if (this.echartsData.length >= 5) {
                option.series[0].label.position = 'outside'
            }
            this.myChart.setOption(option)
        }
    },
    watch:{
        'echartsData':function(nval){
            this.loadEchart()
        }
    }
}
</script>
 
<style scoped>
#unsafeEchart {
    height: 100%;
}
</style>